<template>
  <div class="vehicle-group-dashboard-loss" v-loading="loading">
    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

     <div class="module-title">违章情况</div>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 累计违章 -->
        <HorizontalCardStyle2
          :title="violationNumberData.title"
          :dataDesc="violationNumberData.dataDesc"
          :dataUpdateTime="violationNumberData.dataUpdateTime"
          :btnText="violationNumberData.btnText"
          :primaryDataList="violationNumberData.primaryDataList"
          :secondaryDataList="violationNumberData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 昨日违章 -->
        <HorizontalCardStyle2
          :title="violationNumberYesterdayData.title"
          :dataDesc="violationNumberYesterdayData.dataDesc"
          :dataUpdateTime="violationNumberYesterdayData.dataUpdateTime"
          :btnText="violationNumberYesterdayData.btnText"
          :primaryDataList="violationNumberYesterdayData.primaryDataList"
          :secondaryDataList="violationNumberYesterdayData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 本周违章 -->
        <HorizontalCardStyle2
          :title="violationNumberWeekData.title"
          :dataDesc="violationNumberWeekData.dataDesc"
          :dataUpdateTime="violationNumberWeekData.dataUpdateTime"
          :btnText="violationNumberWeekData.btnText"
          :primaryDataList="violationNumberWeekData.primaryDataList"
          :secondaryDataList="violationNumberWeekData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 本月违章 -->
        <HorizontalCardStyle2
          :title="violationNumberMonthData.title"
          :dataDesc="violationNumberMonthData.dataDesc"
          :dataUpdateTime="violationNumberMonthData.dataUpdateTime"
          :btnText="violationNumberMonthData.btnText"
          :primaryDataList="violationNumberMonthData.primaryDataList"
          :secondaryDataList="violationNumberMonthData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 累计存在待处理违章车辆 -->
        <HorizontalCardStyle1
          :title="violationToDealNumberData.title"
          :dataDesc="violationToDealNumberData.dataDesc"
          :dataUpdateTime="violationToDealNumberData.dataUpdateTime"
          :btnText="violationToDealNumberData.btnText"
          :primaryDataList="violationToDealNumberData.primaryDataList"
          :secondaryDataList="violationToDealNumberData.secondaryDataList"
          @btnClick="$refs.violationGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>

    <div class="module-title">车辆折旧情况</div>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 折旧金额 -->
        <PieChartCard
          :title="depreciationAmountData.title"
          :dataDesc="depreciationAmountData.dataDesc"
          :dataUpdateTime="depreciationAmountData.dataUpdateTime"
          :dataType="depreciationAmountData.dataType"
          :total="depreciationAmountData.total"
          :totalTitle="depreciationAmountData.totalTitle"
          :unit="depreciationAmountData.unit"
          :seriesData="depreciationAmountData.seriesData"
          :dataClick="depreciationAmountData.clickCallback"
        />
      </el-col>
      <el-col :span="12">
        <!-- 折旧车辆数 -->
        <VerticalCardStyle1
          :title="depreciationCarNumberData.title"
          :dataDesc="depreciationCarNumberData.dataDesc"
          :dataUpdateTime="depreciationCarNumberData.dataUpdateTime"
          :btnText="depreciationCarNumberData.btnText"
          :primaryDataList="depreciationCarNumberData.primaryDataList"
          :secondaryDataList="depreciationCarNumberData.secondaryDataList"
           @btnClick="$refs.depreciationGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="24">
        <!-- 维保金额 -->
        <Maintenanceamount
          :title="maintenanceamount.title"
          :dataDesc="maintenanceamount.dataDesc"
          :dataUpdateTime="maintenanceamount.dataUpdateTime"
          :primaryDataList="maintenanceamount.primaryDataList"
          :secondaryDataList="maintenanceamount.secondaryDataList"
          @btnClick="$refs.maintenanceMonthGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>

    <div class="module-title">维修变化趋势(最近30天)</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 新增在修车辆 -->
        <LineChartCard
          :title="newAddMaintenanceData.title"
          :tooltip="newAddMaintenanceData.tooltip"
          :dataDesc="newAddMaintenanceData.dataDesc"
          :dataUpdateTime="newAddMaintenanceData.dataUpdateTime"
          :xAxis="newAddMaintenanceData.xAxis"
          :yAxis="newAddMaintenanceData.yAxis"
          :legendData="newAddMaintenanceData.legendData"
          :seriesData="newAddMaintenanceData.seriesData"
          :unit="newAddMaintenanceData.unit"
        />
      </el-col>

      <el-col :span="12">
        <!-- 累计在修车辆 -->
        <LineChartCard
          :title="totalMaintenanceData.title"
          :tooltip="totalMaintenanceData.tooltip"
          :dataDesc="totalMaintenanceData.dataDesc"
          :dataUpdateTime="totalMaintenanceData.dataUpdateTime"
          :xAxis="totalMaintenanceData.xAxis"
          :yAxis="totalMaintenanceData.yAxis"
          :legendData="totalMaintenanceData.legendData"
          :seriesData="totalMaintenanceData.seriesData"
          :unit="totalMaintenanceData.unit"
        />
      </el-col>
    </el-row>

    <div class="module-title">新增在修车辆分布</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="24">
        <!-- 城市 -->
        <LineChartCard
          :height="newAddCitySpread.height || 344"
          :isShowTooltip="newAddCitySpread.isShowTooltip"
          :title="newAddCitySpread.title"
          :tooltip="newAddCitySpread.tooltip"
          :dataDesc="newAddCitySpread.dataDesc"
          :dataUpdateTime="newAddCitySpread.dataUpdateTime"
          :xAxis="newAddCitySpread.xAxis"
          :yAxis="newAddCitySpread.yAxis"
          :legendData="newAddCitySpread.legendData"
          :seriesData="newAddCitySpread.seriesData"
          :unit="newAddCitySpread.unit"
        />
      </el-col>

      <el-col :span="24">
        <!-- 门店 -->
        <LineChartCard
          :height="newAddStoreSpread.height || 344"
          :isShowTooltip="newAddStoreSpread.isShowTooltip"
          :title="newAddStoreSpread.title"
          :tooltip="newAddStoreSpread.tooltip"
          :dataDesc="newAddStoreSpread.dataDesc"
          :dataUpdateTime="newAddStoreSpread.dataUpdateTime"
          :xAxis="newAddStoreSpread.xAxis"
          :yAxis="newAddStoreSpread.yAxis"
          :legendData="newAddStoreSpread.legendData"
          :seriesData="newAddStoreSpread.seriesData"
          :unit="newAddStoreSpread.unit"
        />
      </el-col>
    </el-row>

    <div class="module-title">累计在修车辆分布</div>
    <el-row class="mb16" :gutter="16">
      <el-col :span="24">
        <!-- 所在城市 -->
        <LineChartCard
          :height="curCitySpread.height || 344"
          :isShowTooltip="curCitySpread.isShowTooltip"
          :title="curCitySpread.title"
          :tooltip="curCitySpread.tooltip"
          :dataDesc="curCitySpread.dataDesc"
          :dataUpdateTime="curCitySpread.dataUpdateTime"
          :xAxis="curCitySpread.xAxis"
          :yAxis="curCitySpread.yAxis"
          :legendData="curCitySpread.legendData"
          :seriesData="curCitySpread.seriesData"
          :unit="curCitySpread.unit"
        />
      </el-col>

      <el-col :span="24">
        <!-- 所在门店 -->
        <LineChartCard
          :height="curStoreSpread.height || 344"
          :isShowTooltip="curStoreSpread.isShowTooltip"
          :title="curStoreSpread.title"
          :tooltip="curStoreSpread.tooltip"
          :dataDesc="curStoreSpread.dataDesc"
          :dataUpdateTime="curStoreSpread.dataUpdateTime"
          :xAxis="curStoreSpread.xAxis"
          :yAxis="curStoreSpread.yAxis"
          :legendData="curStoreSpread.legendData"
          :seriesData="curStoreSpread.seriesData"
          :unit="curStoreSpread.unit"
        />
      </el-col>
    </el-row>

    <div class="module-title">事故情况</div>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 发生事故数量 -->
        <HorizontalCardStyle1
          :title="accidentInfoData.title"
          :dataDesc="accidentInfoData.dataDesc"
          :dataUpdateTime="accidentInfoData.dataUpdateTime"
          :btnText="accidentInfoData.btnText"
          :primaryDataList="accidentInfoData.primaryDataList"
          :secondaryDataList="accidentInfoData.secondaryDataList"
          @btnClick="$refs.accidentNumberData.dialogVisible = true"
        />
      </el-col>
      <el-col :span="12">
        <!-- 累计发生事故车辆 -->
        <HorizontalCardStyle1
          :title="accidentCarNumberData.title"
          :dataDesc="accidentCarNumberData.dataDesc"
          :dataUpdateTime="accidentCarNumberData.dataUpdateTime"
          :btnText="accidentCarNumberData.btnText"
          :primaryDataList="accidentCarNumberData.primaryDataList"
          :secondaryDataList="accidentCarNumberData.secondaryDataList"
          @btnClick="$refs.accidentGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 昨日发生事故车辆 -->
        <HorizontalCardStyle2
          :title="accidentCarNumberYesterdayData.title"
          :dataDesc="accidentCarNumberYesterdayData.dataDesc"
          :dataUpdateTime="accidentCarNumberYesterdayData.dataUpdateTime"
          :btnText="accidentCarNumberYesterdayData.btnText"
          :primaryDataList="accidentCarNumberYesterdayData.primaryDataList"
          :secondaryDataList="accidentCarNumberYesterdayData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 本周发生事故车辆 -->
        <HorizontalCardStyle1
          :title="accidentCarNumberWeekData.title"
          :dataDesc="accidentCarNumberWeekData.dataDesc"
          :dataUpdateTime="accidentCarNumberWeekData.dataUpdateTime"
          :btnText="accidentCarNumberWeekData.btnText"
          :primaryDataList="accidentCarNumberWeekData.primaryDataList"
          :secondaryDataList="accidentCarNumberWeekData.secondaryDataList"
          @btnClick="$refs.accidentWeekGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 本月发生事故车辆 -->
        <HorizontalCardStyle1
          :title="accidentCarNumberMonthData.title"
          :dataDesc="accidentCarNumberMonthData.dataDesc"
          :dataUpdateTime="accidentCarNumberMonthData.dataUpdateTime"
          :btnText="accidentCarNumberMonthData.btnText"
          :primaryDataList="accidentCarNumberMonthData.primaryDataList"
          :secondaryDataList="accidentCarNumberMonthData.secondaryDataList"
          @btnClick="$refs.accidentMonthGradeConfig.dialogVisible = true"
        />
      </el-col>
      <el-col :span="12">
        <!-- 本月保险赔付率 -->
        <HorizontalCardStyle2
          :title="insuranceMonthData.title"
          :dataDesc="insuranceMonthData.dataDesc"
          :dataUpdateTime="insuranceMonthData.dataUpdateTime"
          :btnText="insuranceMonthData.btnText"
          :primaryDataList="insuranceMonthData.primaryDataList"
          :secondaryDataList="insuranceMonthData.secondaryDataList"
        />
      </el-col>
    </el-row>

    <div class="module-title">维修情况</div>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 发生维修次数 -->
        <HorizontalCardStyle1
          :title="maintenanceNumberData.title"
          :dataDesc="maintenanceNumberData.dataDesc"
          :dataUpdateTime="maintenanceNumberData.dataUpdateTime"
          :btnText="maintenanceNumberData.btnText"
          :primaryDataList="maintenanceNumberData.primaryDataList"
          :secondaryDataList="maintenanceNumberData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 累计发生维修车辆 -->
        <HorizontalCardStyle1
          :title="maintenanceCarNumberData.title"
          :dataDesc="maintenanceCarNumberData.dataDesc"
          :dataUpdateTime="maintenanceCarNumberData.dataUpdateTime"
          :btnText="maintenanceCarNumberData.btnText"
          :primaryDataList="maintenanceCarNumberData.primaryDataList"
          :secondaryDataList="maintenanceCarNumberData.secondaryDataList"
          @btnClick="$refs.maintenanceGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 昨日发生维修车辆 -->
        <HorizontalCardStyle2
          :title="maintenanceCarNumberYesterdayData.title"
          :dataDesc="maintenanceCarNumberYesterdayData.dataDesc"
          :dataUpdateTime="maintenanceCarNumberYesterdayData.dataUpdateTime"
          :btnText="maintenanceCarNumberYesterdayData.btnText"
          :primaryDataList="maintenanceCarNumberYesterdayData.primaryDataList"
          :secondaryDataList="maintenanceCarNumberYesterdayData.secondaryDataList"
        />
      </el-col>
      <el-col :span="12">
        <!-- 本周发生维修车辆 -->
        <HorizontalCardStyle1
          :title="maintenanceCarNumberWeekData.title"
          :dataDesc="maintenanceCarNumberWeekData.dataDesc"
          :dataUpdateTime="maintenanceCarNumberWeekData.dataUpdateTime"
          :btnText="maintenanceCarNumberWeekData.btnText"
          :primaryDataList="maintenanceCarNumberWeekData.primaryDataList"
          :secondaryDataList="maintenanceCarNumberWeekData.secondaryDataList"
          @btnClick="$refs.maintenanceWeekGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 本月发生维修车辆 -->
        <HorizontalCardStyle1
          :title="maintenanceCarNumberMonthData.title"
          :dataDesc="maintenanceCarNumberMonthData.dataDesc"
          :dataUpdateTime="maintenanceCarNumberMonthData.dataUpdateTime"
          :btnText="maintenanceCarNumberMonthData.btnText"
          :primaryDataList="maintenanceCarNumberMonthData.primaryDataList"
          :secondaryDataList="maintenanceCarNumberMonthData.secondaryDataList"
          @btnClick="$refs.maintenanceMonthGradeConfig.dialogVisible = true"
        />
      </el-col>
    </el-row>


    <!-- 累计折旧费分级配置 -->
    <DepreciationLevelModal
      ref="depreciationGradeConfig"
      title="累计折旧费分级配置"
      name="单车累计产生折旧费"
      unit="万元"
      :defaultData="depreciationGradeConfig"
      @change="submitDepreciationGradeConfig"
    />

    <!-- 累计事故次数分级配置 -->
    <AccidentTimesLevelModal
      ref="accidentGradeConfig"
      title="累计事故次数分级配置"
      name="单车累计发生事故次数"
      unit="次"
      :defaultData="accidentGradeConfig"
      @change="submitAccidentGradeConfig"
    />

    <!-- 本周事故次数分级配置 -->
    <AccidentTimesLevelModal
      ref="accidentWeekGradeConfig"
      title="本周事故次数分级配置"
      name="单车本周发生事故次数"
      unit="次"
      :defaultData="accidentWeekGradeConfig"
      @change="submitAccidentWeekGradeConfig"
    />

    <!-- 本月事故次数分级配置 -->
    <AccidentTimesLevelModal
      ref="accidentMonthGradeConfig"
      title="本月事故次数分级配置"
      name="单车本月发生事故次数"
      unit="次"
      :defaultData="accidentMonthGradeConfig"
      @change="submitAccidentMonthGradeConfig"
    />

    <!-- 累计维修次数分级配置 -->
    <MaintainTimesLevelModal
      ref="maintenanceGradeConfig"
      title="累计维修次数分级配置"
      name="单车累计发生维修次数"
      unit="次"
      :defaultData="maintenanceGradeConfig"
      @change="submitMaintenanceGradeConfig"
    />

    <!-- 本周维修次数分级配置 -->
    <MaintainTimesLevelModal
      ref="maintenanceWeekGradeConfig"
      title="本周维修次数分级配置"
      name="单车本周发生维修次数"
      unit="次"
      :defaultData="maintenanceWeekGradeConfig"
      @change="submitMaintenanceWeekGradeConfig"
    />

    <!-- 本月维修次数分级配置 -->
    <MaintainTimesLevelModal
      ref="maintenanceMonthGradeConfig"
      title="本月维修次数分级配置"
      name="单车本月发生维修次数"
      unit="次"
      :defaultData="maintenanceMonthGradeConfig"
      @change="submitMaintenanceMonthGradeConfig"
    />

    <!-- 违章管理配置 -->
    <ViolationManageModal
      ref="violationGradeConfig"
      title="违章管理配置"
      :defaultData="violationGradeConfig"
      @change="submitViolationGradeConfig"
    />

    <!-- 事故数量(责任纬度视角) -->
    <AccidentAmountModal
      ref="accidentNumberData"
      title="事故数量(责任纬度视角)"
      :data="accidentNumberData"
    />
  </div>
</template>
<script>
import FiltersBox from '@/bizComponents/Dashboard/filtersBox'
import HorizontalCardStyle1 from '@/bizComponents/Dashboard/cards/horizontalCard/style1.vue'
import HorizontalCardStyle2 from '@/bizComponents/Dashboard/cards/horizontalCard/style2.vue'
import VerticalCardStyle1 from '@/bizComponents/Dashboard/cards/verticalCard/style1.vue'
import PieChartCard from '@/bizComponents/Dashboard/cards/pieChartCard'
import DepreciationLevelModal from '@/bizComponents/Dashboard/modals/depreciationLevelModal'
import AccidentTimesLevelModal from '@/bizComponents/Dashboard/modals/accidentTimesLevelModal'
import MaintainTimesLevelModal from '@/bizComponents/Dashboard/modals/maintainTimesLevelModal'
import AccidentAmountModal from '@/bizComponents/Dashboard/modals/accidentAmountModal'
import ViolationManageModal from '@/bizComponents/Dashboard/modals/violationManageModal'
import Maintenanceamount from '@/bizComponents/Dashboard/cards/maintenance/maintenanceamount.vue'
import {
  getVehicleViolationInfo,
  getVehicleMaintenanceInfo,
  getVehicleDepreciationInfo,
  getVehicleAccidentInfo,
  getVehicleAccidentNumber,
  getGradeConfig,
  getGradeConfigRecord,
  saveGradeConfig,
  getViolationGradeConfig,
  saveViolationGradeConfig,
} from '@/api/domain/vehicle'
import { convertNumber } from '@/utils/'
import { yesterday, thisWeekT_1, thisMonthT_1 } from '../../config'
import { vehicleMaintenancePayInfoApi, vehicleMaintenanceLineApi, vehicleMaintenanceDistributionApi } from './services'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard'
import configData from './config'

export default {
  components: {
    FiltersBox,
    HorizontalCardStyle1,
    HorizontalCardStyle2,
    VerticalCardStyle1,
    PieChartCard,
    DepreciationLevelModal,
    AccidentTimesLevelModal,
    MaintainTimesLevelModal,
    AccidentAmountModal,
    ViolationManageModal,
    Maintenanceamount,
    LineChartCard,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    const {
      newAddMaintenanceData,
      totalMaintenanceData,
      newAddCitySpread,
      newAddStoreSpread,
      curCitySpread,
      curStoreSpread,
    } = configData.call(this)
    return {
      newAddMaintenanceData,
      totalMaintenanceData,
      newAddCitySpread,
      newAddStoreSpread,
      curCitySpread,
      curStoreSpread,
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
          showRatio: true,
        },
      },
      // 折旧金额
      depreciationAmountData: {
        title: '折旧金额',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        dataType: 'amount',
        totalTitle: '当前累计折旧金额',
        total: '',
        unit: '元',
        seriesData: [],
      },
      // 折旧车辆数
      depreciationCarNumberData: {
        title: '折旧车辆数',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        btnText: '设置折旧分级',
        primaryDataList: [],
        secondaryDataList: [],
      },
      maintenanceamount: {
        title: '维保金额',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 发生事故数量
      accidentInfoData: {
        title: '发生事故数量',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        btnText: '责任纬度视角',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 事故数量(责任纬度视角)
      accidentNumberData: {
        title: '事故数量(责任纬度视角)',
        data: {
          total: {
            dataList: [],
          },
          day: {
            dataList: [],
          },
          week: {
            dataList: [],
          },
          month: {
            dataList: [],
          },
        },
      },
      // 累计发生事故车辆
      accidentCarNumberData: {
        title: '累计发生事故车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        // 只在集团权限下展示
        btnText: '调整累计事故分级',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日发生事故车辆
      accidentCarNumberYesterdayData: {
        title: '昨日发生事故车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 本周发生事故车辆
      accidentCarNumberWeekData: {
        title: '本周发生事故车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        // 只在集团权限下展示
        btnText: '调整本周事故分级',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 本月发生事故车辆
      accidentCarNumberMonthData: {
        title: '本月发生事故车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        // 只在集团权限下展示
        btnText: '调整本月事故分级',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 本月保险赔付率
      insuranceMonthData: {
        title: '本月保险赔付率',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 发生维修次数
      maintenanceNumberData: {
        title: '发生维修次数',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 累计发生维修车辆
      maintenanceCarNumberData: {
        title: '累计发生维修车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        // 只在集团权限下展示
        btnText: '调整累计维修次数分级',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日发生维修车辆
      maintenanceCarNumberYesterdayData: {
        title: '昨日发生维修车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 本周发生维修车辆
      maintenanceCarNumberWeekData: {
        title: '本周发生维修车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        // 只在集团权限下展示
        btnText: '调整本周维修次数分级',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 本月发生维修车辆
      maintenanceCarNumberMonthData: {
        title: '本月发生维修车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        // 只在集团权限下展示
        btnText: '调整维修次数分级',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 累计违章
      violationNumberData: {
        title: '累计违章',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 昨日违章
      violationNumberYesterdayData: {
        title: '昨日违章',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 本周违章
      violationNumberWeekData: {
        title: '本周违章',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 本月违章
      violationNumberMonthData: {
        title: '本月违章',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 累计存在待处理违章车辆
      violationToDealNumberData: {
        title: '累计存在待处理违章车辆',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        primaryDataList: [],
        secondaryDataList: [],
      },
      // 折旧分级（最新）
      depreciationGradeConfig: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 累计事故分级（最新）
      accidentGradeConfig: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本周事故分级（最新）
      accidentWeekGradeConfig: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本月事故分级（最新）
      accidentMonthGradeConfig: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 累计维修次数分级（最新）
      maintenanceGradeConfig: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本周维修次数分级（最新）
      maintenanceWeekGradeConfig: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本月维修次数分级（最新）
      maintenanceMonthGradeConfig: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 违章预警分级
      violationGradeConfig: {
        riskScore: 0,
        riskFine: 0,
        highRiskScore: 0,
        highRiskFine: 0,
        overtimeDays: 0,
      },
      // 折旧分级
      depreciationGradeConfigRecord: {
        firstLevel1: 0,
        firstLevel2: 0, // eslint-disable-line vue/no-unused-properties
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 累计事故分级
      accidentGradeConfigRecord: {
        firstLevel1: 0,
        firstLevel2: 0, // eslint-disable-line vue/no-unused-properties
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本周事故分级
      accidentWeekGradeConfigRecord: {
        firstLevel1: 0,
        firstLevel2: 0, // eslint-disable-line vue/no-unused-properties
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本月事故分级
      /* eslint-disable vue/no-unused-properties */
      accidentMonthGradeConfigRecord: {
        firstLevel1: 0,
        firstLevel2: 0,
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      /* eslint-enable vue/no-unused-properties */
      // 累计维修次数分级
      maintenanceGradeConfigRecord: {
        firstLevel1: 0,
        firstLevel2: 0, // eslint-disable-line vue/no-unused-properties
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本周维修次数分级
      maintenanceWeekGradeConfigRecord: {
        firstLevel1: 0,
        firstLevel2: 0, // eslint-disable-line vue/no-unused-properties
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      // 本月维修次数分级
      maintenanceMonthGradeConfigRecord: {
        firstLevel1: 0,
        firstLevel2: 0, // eslint-disable-line vue/no-unused-properties
        secondLevel1: 0,
        secondLevel2: 0,
        thirdLevel1: 0,
      },
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    params() {
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
      }
    },
    // 根部门ID
    rootDeptId() {
      return this.$store.getters.userInfo.rootDeptId
    },
    // 路由部门ID参数
    routerDeptId() {
      const selectedDeptId = this.globalFilter.model.deptId
      return selectedDeptId === this.rootDeptId ? '' : selectedDeptId
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    const init = async () => {
      this.loading = true
      await Promise.all([
        this.updateGradeConfig(),
        this.updateGradeConfigRecord(),
      ]).finally(() => {
        this.loading = false
      })
      this.update()
    }
    init()
  },
  methods: {
    update() {
      this.updateCardData()
    },
    async updateGradeConfig() {
      await Promise.all([
        this.getDepreciationGradeConfig(),
        this.getAccidentGradeConfig(),
        this.getAccidentWeekGradeConfig(),
        this.getAccidentMonthGradeConfig(),
        this.getMaintenanceGradeConfig(),
        this.getMaintenanceWeekGradeConfig(),
        this.getMaintenanceMonthGradeConfig(),
        this.getViolationGradeConfig(),
      ])
    },
    async updateGradeConfigRecord() {
      await Promise.all([
        this.getDepreciationGradeConfigRecord(),
        this.getAccidentGradeConfigRecord(),
        this.getAccidentWeekGradeConfigRecord(),
        this.getAccidentMonthGradeConfigRecord(),
        this.getMaintenanceGradeConfigRecord(),
        this.getMaintenanceWeekGradeConfigRecord(),
        this.getMaintenanceMonthGradeConfigRecord(),
      ])
    },
    updateCardData() {
      this.loading = true
      Promise.all([
        this.vehicleMaintenancePayInfo(),
        this.vehicleMaintenanceLine(),
        this.vehicleMaintenanceDistribution(),
        this.getVehicleDepreciationInfo(),
        this.getVehicleAccidentInfo(),
        this.getVehicleAccidentNumber(),
        this.getVehicleMaintenanceInfo(),
        this.getVehicleViolationInfo(),
      ]).finally(() => {
        this.loading = false
      })
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    // 跳转财务-应收管理
    toFinanceCollectionList({ content, sourceOrderType }) {
      const query = {
        deptId: this.routerDeptId,
      }
      // 收款内容 29: 车辆折旧费
      if (typeof content !== 'undefined') {
        query.content = content
      }
      // 来源单类型 1:出入库记录 2:车辆租赁合同 3:维保单 4:事故单 5:采购订单 6:企业租赁订单
      if (typeof sourceOrderType !== 'undefined') {
        query.sourceOrderType = sourceOrderType
      }
      this.$router.push({
        path: '/finance/collection',
        query,
      })
    },
    // 跳转车辆-事故管理
    toAccidentList({ value1, accidentBlame }) {
      const query = {
        deptId: this.routerDeptId,
      }
      // 报案日区间 ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']
      if (typeof value1 !== 'undefined') {
        query.value1 = JSON.stringify(value1)
      }
      // 事故责任类型 1:主要责任 2:次要责任 3:无责 4:全责 5:同责
      if (typeof accidentBlame !== 'undefined') {
        query.accidentBlame = accidentBlame
      }
      this.$router.push({
        path: '/vehicle/accident/list',
        query,
      })
    },
    // 跳转车辆-维保
    toMaintenanceList({ value1, type }) {
      const query = {}
      // 送厂时间 ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']
      if (typeof value1 !== 'undefined') {
        query.value1 = JSON.stringify(value1)
      }
      // 维保类型 1:维修
      if (typeof type !== 'undefined') {
        query.type = type
      }
      this.$router.push({
        path: '/vehicle/maintenance/list',
        query,
      })
    },
    // 跳转车辆-违章记录
    toViolationRecord({ violationTime }) {
      const query = {
        deptId: this.routerDeptId,
      }
      // 违章时间 ['YYYY-MM-DD HH:mm:ss', 'YYYY-MM-DD HH:mm:ss']
      if (typeof violationTime !== 'undefined') {
        query.violationTime = JSON.stringify(violationTime)
      }
      this.$router.push({
        path: '/vehicle/violation/record',
        query,
      })
    },
    // 事故数量(责任维度视角)
    async getVehicleAccidentNumber() {
      const res = await getVehicleAccidentNumber(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        const {
          vehicleAccidentTotalVO,
          vehicleAccidentDayVO,
          vehicleAccidentWeekVO,
          vehicleAccidentMonthVO,
        } = data
        // 累计事故
        this.accidentNumberData.data.total.dataList = [
          {
            name: '累计事故数量',
            value: vehicleAccidentTotalVO.totalNumber || 0,
          },
          {
            name: '全责数量',
            value: vehicleAccidentTotalVO.wholeNumber || 0,
            ratio: vehicleAccidentTotalVO.wholeRate || 0,
            clickCallback: () => this.toAccidentList({
              accidentBlame: 4,
            }),
          },
          {
            name: '主要责任数量',
            value: vehicleAccidentTotalVO.mainNumber || 0,
            ratio: vehicleAccidentTotalVO.mainRate || 0,
            clickCallback: () => this.toAccidentList({
              accidentBlame: 1,
            }),
          },
          {
            name: '次要责任数量',
            value: vehicleAccidentTotalVO.secondaryNumber || 0,
            ratio: vehicleAccidentTotalVO.secondaryRate || 0,
            clickCallback: () => this.toAccidentList({
              accidentBlame: 2,
            }),
          },
          {
            name: '同责数量',
            value: vehicleAccidentTotalVO.sharedNumber || 0,
            ratio: vehicleAccidentTotalVO.sharedRate || 0,
            clickCallback: () => this.toAccidentList({
              accidentBlame: 5,
            }),
          },
          {
            name: '无责数量',
            value: vehicleAccidentTotalVO.noNumber || 0,
            ratio: vehicleAccidentTotalVO.noRate || 0,
            clickCallback: () => this.toAccidentList({
              accidentBlame: 3,
            }),
          },
        ]
        // 昨日事故
        this.accidentNumberData.data.day.dataList = [
          {
            name: '昨日事故数量',
            value: vehicleAccidentDayVO.totalNumber || 0,
          },
          {
            name: '全责数量',
            value: vehicleAccidentDayVO.wholeNumber || 0,
            ratio: vehicleAccidentDayVO.wholeRate || 0,
            ratioList: [
              {
                name: '日环比',
                value: vehicleAccidentDayVO.wholeDayRadio,
              },
              {
                name: '周同比',
                value: vehicleAccidentDayVO.wholeWeekYoY,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 4,
            }),
          },
          {
            name: '主要责任数量',
            value: vehicleAccidentDayVO.mainNumber || 0,
            ratio: vehicleAccidentDayVO.mainRate || 0,
            ratioList: [
              {
                name: '日环比',
                value: vehicleAccidentDayVO.mainDayRadio,
              },
              {
                name: '周同比',
                value: vehicleAccidentDayVO.mainWeekYoY,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 1,
            }),
          },
          {
            name: '次要责任数量',
            value: vehicleAccidentDayVO.secondaryNumber || 0,
            ratio: vehicleAccidentDayVO.secondaryRate || 0,
            ratioList: [
              {
                name: '日环比',
                value: vehicleAccidentDayVO.secondaryDayRadio,
              },
              {
                name: '周同比',
                value: vehicleAccidentDayVO.secondaryWeekYoY,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 3,
            }),
          },
          {
            name: '同责数量',
            value: vehicleAccidentDayVO.sharedNumber || 0,
            ratio: vehicleAccidentDayVO.sharedRate || 0,
            ratioList: [
              {
                name: '日环比',
                value: vehicleAccidentDayVO.sharedDayRadio,
              },
              {
                name: '周同比',
                value: vehicleAccidentDayVO.sharedWeekYoY,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 5,
            }),
          },
          {
            name: '无责数量',
            value: vehicleAccidentDayVO.noNumber || 0,
            ratio: vehicleAccidentDayVO.noRate || 0,
            ratioList: [
              {
                name: '日环比',
                value: vehicleAccidentDayVO.noDayRadio,
              },
              {
                name: '周同比',
                value: vehicleAccidentDayVO.noWeekYoY,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 3,
            }),
          },
        ]
        // 本周事故
        this.accidentNumberData.data.week.dataList = [
          {
            name: '本周事故数量',
            value: vehicleAccidentWeekVO.totalNumber || 0,
          },
          {
            name: '全责数量',
            value: vehicleAccidentWeekVO.wholeNumber || 0,
            ratio: vehicleAccidentWeekVO.wholeRate || 0,
            ratioList: [
              {
                name: '周环比',
                value: vehicleAccidentWeekVO.wholeWeekRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 4,
            }),
          },
          {
            name: '主要责任数量',
            value: vehicleAccidentWeekVO.mainNumber || 0,
            ratio: vehicleAccidentWeekVO.mainRate || 0,
            ratioList: [
              {
                name: '周环比',
                value: vehicleAccidentWeekVO.mainWeekRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 1,
            }),
          },
          {
            name: '次要责任数量',
            value: vehicleAccidentWeekVO.secondaryNumber || 0,
            ratio: vehicleAccidentWeekVO.secondaryRate || 0,
            ratioList: [
              {
                name: '周环比',
                value: vehicleAccidentWeekVO.secondaryWeekRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 2,
            }),
          },
          {
            name: '同责数量',
            value: vehicleAccidentWeekVO.sharedNumber || 0,
            ratio: vehicleAccidentWeekVO.sharedRate || 0,
            ratioList: [
              {
                name: '周环比',
                value: vehicleAccidentWeekVO.sharedWeekRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 5,
            }),
          },
          {
            name: '无责数量',
            value: vehicleAccidentWeekVO.noNumber || 0,
            ratio: vehicleAccidentWeekVO.noRate || 0,
            ratioList: [
              {
                name: '周环比',
                value: vehicleAccidentWeekVO.noDayWeekRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 3,
            }),
          },
        ]
        // 本月事故
        this.accidentNumberData.data.month.dataList = [
          {
            name: '本月事故数量',
            value: vehicleAccidentMonthVO.totalNumber || 0,
          },
          {
            name: '全责数量',
            value: vehicleAccidentMonthVO.wholeNumber || 0,
            ratio: vehicleAccidentMonthVO.wholeRate || 0,
            ratioList: [
              {
                name: '月环比',
                value: vehicleAccidentMonthVO.wholeMonthRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 4,
            }),
          },
          {
            name: '主要责任数量',
            value: vehicleAccidentMonthVO.mainNumber || 0,
            ratio: vehicleAccidentMonthVO.mainRate || 0,
            ratioList: [
              {
                name: '月环比',
                value: vehicleAccidentMonthVO.mainMonthRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 1,
            }),
          },
          {
            name: '次要责任数量',
            value: vehicleAccidentMonthVO.secondaryNumber || 0,
            ratio: vehicleAccidentMonthVO.secondaryRate || 0,
            ratioList: [
              {
                name: '月环比',
                value: vehicleAccidentMonthVO.secondaryMonthRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 2,
            }),
          },
          {
            name: '同责数量',
            value: vehicleAccidentMonthVO.sharedNumber || 0,
            ratio: vehicleAccidentMonthVO.sharedRate || 0,
            ratioList: [
              {
                name: '月环比',
                value: vehicleAccidentMonthVO.sharedMonthRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 5,
            }),
          },
          {
            name: '无责数量',
            value: vehicleAccidentMonthVO.noNumber || 0,
            ratio: vehicleAccidentMonthVO.noRate || 0,
            ratioList: [
              {
                name: '月环比',
                value: vehicleAccidentMonthVO.noDayMonthRadio,
              },
            ],
            clickCallback: () => this.toAccidentList({
              accidentBlame: 3,
            }),
          },
        ]
      }
    },
    // 获取车辆折旧情况
    async getVehicleDepreciationInfo() {
      const res = await getVehicleDepreciationInfo(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        // 折旧金额
        this.depreciationAmountData.dataUpdateTime = data.updateTime || ''
        this.depreciationAmountData.total = data.totalDepreciationAmount || 0
        // 财务-应收-应收管理，筛选条件中的收款内容选择“车辆折旧费”
        this.depreciationAmountData.clickCallback = () => this.toFinanceCollectionList({
          content: 29,
        })
        this.depreciationAmountData.seriesData = [
          {
            name: '事故折旧金额',
            value: data.accidentDepreciationAmount || 0,
            ratio: data.accidentDepreciationAmountRate || 0,
            // 财务-应收-应收管理，筛选条件中的收款内容选择“车辆折旧费”、来源单类型选择“事故单”
            clickCallback: () => this.toFinanceCollectionList({
              content: 29,
              sourceOrderType: 4,
            }),
          },
          {
            name: '维保折旧金额',
            value: data.maintenanceDepreciationAmount || 0,
            ratio: data.maintenanceDepreciationAmountRate || 0,
            // 财务-应收-应收管理，筛选条件中的收款内容选择“车辆折旧费”、来源单类型选择“维保单”
            clickCallback: () => this.toFinanceCollectionList({
              content: 29,
              sourceOrderType: 3,
            }),
          },
          {
            name: '个人租赁折旧金额',
            value: data.rentDepreciationAmount || 0,
            ratio: data.rentDepreciationAmountRate || 0,
            // 财务-应收-应收管理，筛选条件中的收款内容选择“车辆折旧费”、来源单类型选择“车辆租赁合同”
            clickCallback: () => this.toFinanceCollectionList({
              content: 29,
              sourceOrderType: 2,
            }),
          },
          {
            name: '企业租赁折旧金额',
            value: data.entDepreciationAmount || 0,
            ratio: data.entDepreciationAmountRate || 0,
            // 财务-应收-应收管理，筛选条件中的收款内容选择“车辆折旧费”、来源单类型选择“企业租赁订单”
            clickCallback: () => this.toFinanceCollectionList({
              content: 29,
              sourceOrderType: 6,
            }),
          },
        ]
        // 折旧车辆数
        this.depreciationCarNumberData.dataUpdateTime = data.updateTime || ''
        this.depreciationCarNumberData.primaryDataList = [
          {
            label: '当前累计产生折旧费车辆数',
            value: data.totalCarNumber || 0,
            unit: '辆',
            tooltip: '“车辆折旧费”金额大于0的车辆数',
          },
        ]
        this.depreciationCarNumberData.secondaryDataList = [
          {
            label: `累计折旧费小于${this.depreciationGradeConfigRecord.firstLevel1}万`,
            value: data.level1CarNumber || 0,
            ratio: data.level1CarNumberRate || 0,
            unit: '辆',
            tooltip: '按照折旧分级配置规则，分类统计的产生折旧费车辆数',
          },
          {
            label: `累计折旧费${this.depreciationGradeConfigRecord.secondLevel1}～${this.depreciationGradeConfigRecord.secondLevel2}万`,
            value: data.level2CarNumber || 0,
            ratio: data.level2CarNumberRate || 0,
            unit: '辆',
            tooltip: '按照折旧分级配置规则，分类统计的产生折旧费车辆数',
          },
          {
            label: `累计折旧费大于${this.depreciationGradeConfigRecord.thirdLevel1}万`,
            value: data.level3CarNumber || 0,
            ratio: data.level3CarNumberRate || 0,
            unit: '辆',
            tooltip: '按照折旧分级配置规则，分类统计的产生折旧费车辆数',
          },
        ]
      }
    },
    // 获取事故情况
    async getVehicleAccidentInfo() {
      const res = await getVehicleAccidentInfo(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        // 发生事故数量
        this.accidentInfoData.dataUpdateTime = data.updateTimeOfNumber || ''
        this.accidentInfoData.primaryDataList = [
          {
            label: '累计事故数量',
            value: data.totalNumber || 0,
            unit: '次',
            tooltip: '累计发生事故数量',
            // 车辆-事故管理
            clickCallback: () => this.toAccidentList({}),
          },
        ]
        this.accidentInfoData.secondaryDataList = [
          {
            label: '昨日事故数量',
            value: data.yesterdayNumber || 0,
            unit: '次',
            tooltip: '事故报案日为昨日的发生事故数量',
            ratioList: [
              {
                name: '日环比',
                value: data.yesterdayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.yesterdayNumberWeekYoY,
              },
            ],
            // 车辆-事故管理，报案日区间选取昨日
            clickCallback: () => this.toAccidentList({
              value1: yesterday,
            }),
          },
          {
            label: '本周事故数量',
            value: data.totalNumberOfWeek || 0,
            unit: '次',
            tooltip: '事故报案日时间区间为本周的发生事故数量',
            ratioList: [
              {
                name: '周环比',
                value: data.totalNumberOfWeekRadio,
              },
            ],
            // 车辆-事故管理，报案日区间选取本周
            clickCallback: () => this.toAccidentList({
              value1: thisWeekT_1,
            }),
          },
          {
            label: '本月事故数量',
            value: data.totalNumberOfMonth || 0,
            unit: '次',
            tooltip: '事故报案日时间区间为本月的为昨日的发生事故数量',
            ratioList: [
              {
                name: '月环比',
                value: data.totalNumberOfMonthRadio,
              },
            ],
            // 车辆-事故管理，报案日区间选取本月
            clickCallback: () => this.toAccidentList({
              value1: thisMonthT_1,
            }),
          },
        ]

        // 累计发生事故车辆
        this.accidentCarNumberData.dataUpdateTime = data.updateTimeOfTotalNumber || ''
        this.accidentCarNumberData.primaryDataList = [
          {
            label: '事故车辆总数',
            value: data.totalCarNumber || 0,
            unit: '辆',
            tooltip: '发生事故次数大于0的车辆累计数量',
          },
        ]
        this.accidentCarNumberData.secondaryDataList = [
          {
            label: `${this.accidentGradeConfigRecord.firstLevel1}次以下`,
            value: data.carNumberLevel1 || 0,
            unit: '辆',
            tooltip: '按照累计事故次数分级配置规则，分类统计的发生事故车辆数',
          },
          {
            label: `${this.accidentGradeConfigRecord.secondLevel1}~${this.accidentGradeConfigRecord.secondLevel2}次`,
            value: data.carNumberLevel2 || 0,
            unit: '辆',
            tooltip: '按照累计事故次数分级配置规则，分类统计的发生事故车辆数',
          },
          {
            label: `${this.accidentGradeConfigRecord.thirdLevel1}次以上`,
            value: data.carNumberLevel3 || 0,
            unit: '辆',
            tooltip: '按照累计事故次数分级配置规则，分类统计的发生事故车辆数',
          },
        ]

        // 昨日发生事故车辆
        this.accidentCarNumberYesterdayData.dataUpdateTime = data.updateTimeOfYesterday || ''
        this.accidentCarNumberYesterdayData.primaryDataList = [
          {
            label: '事故车辆数',
            value: data.carNumberOfYesterday || 0,
            unit: '辆',
            tooltip: '昨日发生事故次数大于0的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data.carNumberOfYesterdayDayRadio,
              },
              {
                name: '周同比',
                value: data.carNumberOfYesterdayWeekYoY,
              },
            ],
          },
        ]

        // 本周发生事故车辆
        this.accidentCarNumberWeekData.dataUpdateTime = data.updateTimeOfWeek || ''
        this.accidentCarNumberWeekData.primaryDataList = [
          {
            label: '事故车辆总数',
            value: data.totalCarNumberOfWeek || 0,
            unit: '辆',
            tooltip: '本周时间段内发生事故次数大于0的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data.totalCarNumberOfWeekRadio,
              },
            ],
          },
        ]
        this.accidentCarNumberWeekData.secondaryDataList = [
          {
            label: `${this.accidentWeekGradeConfigRecord.firstLevel1}次以下`,
            value: data.carNumberOfWeekLevel1 || 0,
            unit: '辆',
            tooltip: '按照本周事故次数分级配置规则，分类统计的发生事故车辆数',
            ratioList: [
              {
                name: '周环比',
                value: data.carNumberOfWeekLevel1WeekRadio,
              },
            ],
          },
          {
            label: `${this.accidentWeekGradeConfigRecord.secondLevel1}~${this.accidentWeekGradeConfigRecord.secondLevel2}次`,
            value: data.carNumberOfWeekLevel2 || 0,
            unit: '辆',
            tooltip: '按照本周事故次数分级配置规则，分类统计的发生事故车辆数',
            ratioList: [
              {
                name: '周环比',
                value: data.carNumberOfWeekLevel2WeekRadio,
              },
            ],
          },
          {
            label: `${this.accidentWeekGradeConfigRecord.thirdLevel1}次以上`,
            value: data.carNumberOfWeekLevel3 || 0,
            unit: '辆',
            tooltip: '按照本周事故次数分级配置规则，分类统计的发生事故车辆数',
            ratioList: [
              {
                name: '周环比',
                value: data.carNumberOfWeekLevel3WeekRadio,
              },
            ],
          },
        ]

        // 本月发生事故车辆
        this.accidentCarNumberMonthData.dataUpdateTime = data.updateTimeOfMonth || ''
        this.accidentCarNumberMonthData.primaryDataList = [
          {
            label: '事故车辆总数',
            value: data.totalCarNumberOfMonth || 0,
            unit: '辆',
            tooltip: '本月时间段内发生事故次数大于0的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data.totalCarNumberOfMonthRadio,
              },
            ],
          },
        ]
        this.accidentCarNumberMonthData.secondaryDataList = [
          {
            label: `${this.accidentWeekGradeConfigRecord.firstLevel1}次以下`,
            value: data.carNumberOfMonthLevel1 || 0,
            unit: '辆',
            tooltip: '按照本月事故次数分级配置规则，分类统计的发生事故车辆数',
            ratioList: [
              {
                name: '月环比',
                value: data.carNumberOfMonthLevel1MonthRadio,
              },
            ],
          },
          {
            label: `${this.accidentWeekGradeConfigRecord.secondLevel1}~${this.accidentWeekGradeConfigRecord.secondLevel2}次`,
            value: data.carNumberOfMonthLevel2 || 0,
            unit: '辆',
            tooltip: '按照本月事故次数分级配置规则，分类统计的发生事故车辆数',
            ratioList: [
              {
                name: '月环比',
                value: data.carNumberOfMonthLevel2MonthRadio,
              },
            ],
          },
          {
            label: `${this.accidentWeekGradeConfigRecord.thirdLevel1}次以上`,
            value: data.carNumberOfMonthLevel3 || 0,
            unit: '辆',
            tooltip: '按照本月事故次数分级配置规则，分类统计的发生事故车辆数',
            ratioList: [
              {
                name: '月环比',
                value: data.carNumberOfMonthLevel3MonthRadio,
              },
            ],
          },
        ]

        // 本月保险赔付率
        this.insuranceMonthData.dataUpdateTime = data.updateTimeOfInsure || ''
        this.insuranceMonthData.primaryDataList = [
          {
            label: '保险赔付率',
            value: (data.insuranceCompensation || 0) * 100,
            unit: '%',
            tooltip: '本月保险赔付率=本月保险公司总赔付金额/∑（投保金额/12）统计包含交强险、商业险',
            ratioList: [
              {
                name: '月环比',
                value: data.insuranceCompensationMonthRadio,
              },
            ],
          },
        ]
      }
    },
    // 获取维修情况
    async getVehicleMaintenanceInfo() {
      const res = await getVehicleMaintenanceInfo(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        // 发生维修次数
        this.maintenanceNumberData.dataUpdateTime = data.updateTimeOfNumber || ''
        this.maintenanceNumberData.primaryDataList = [
          {
            label: '累计维修次数',
            value: data.totalNumber || 0,
            unit: '次',
            tooltip: '“维保类型”为维修的总数量',
            // 车辆-维保，筛选条件中的维保类型带入“维修”
            clickCallback: () => this.toMaintenanceList({
              type: 1,
            }),
          },
        ]
        this.maintenanceNumberData.secondaryDataList = [
          {
            label: '昨日维修数量',
            value: data.yesterdayNumber || 0,
            unit: '次',
            tooltip: '“送厂时间”为昨日、“维保类型”为维修的数量',
            ratioList: [
              {
                name: '日环比',
                value: data.yesterdayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.yesterdayNumberWeekYoY,
              },
            ],
            // 车辆-维保，筛选条件中的维保类型带入“维修”、送厂时间选择昨日
            clickCallback: () => this.toMaintenanceList({
              type: 1,
              value1: yesterday,
            }),
          },
          {
            label: '本周维修数量',
            value: data.totalNumberOfWeek || 0,
            unit: '次',
            tooltip: '“送厂时间”时间段为本周、“维保类型”为维修的数量',
            ratioList: [
              {
                name: '周环比',
                value: data.totalNumberOfWeekRadio,
              },
            ],
            // 车辆-维保，筛选条件中的维保类型带入“维修”、送厂时间选择本周时间区间
            clickCallback: () => this.toMaintenanceList({
              type: 1,
              value1: thisWeekT_1,
            }),
          },
          {
            label: '本月维修数量',
            value: data.totalNumberOfMonth || 0,
            unit: '次',
            tooltip: '“送厂时间”时间段为本月、“维保类型”为维修的数量',
            ratioList: [
              {
                name: '月环比',
                value: data.totalNumberOfMonthRadio,
              },
            ],
            // 车辆-维保，筛选条件中的维保类型带入“维修”、送厂时间选择本月时间区间
            clickCallback: () => this.toMaintenanceList({
              type: 1,
              value1: thisMonthT_1,
            }),
          },
        ]

        // 累计发生维修车辆
        this.maintenanceCarNumberData.dataUpdateTime = data.updateTimeOfTotalNumber || ''
        this.maintenanceCarNumberData.primaryDataList = [
          {
            label: '维修车辆总数',
            value: data.totalCarNumber || 0,
            unit: '辆',
            tooltip: '发生维修次数大于0的车辆累计数量',
          },
        ]
        this.maintenanceCarNumberData.secondaryDataList = [
          {
            label: `${this.maintenanceGradeConfigRecord.firstLevel1}次以下`,
            value: data.carNumberLevel1 || 0,
            unit: '辆',
            tooltip: '按照累计维修次数分级配置规则，分类统计的发生维修车辆数',
          },
          {
            label: `${this.maintenanceGradeConfigRecord.secondLevel1}~${this.maintenanceGradeConfigRecord.secondLevel2}次`,
            value: data.carNumberLevel2 || 0,
            unit: '辆',
            tooltip: '按照累计维修次数分级配置规则，分类统计的发生维修车辆数',
          },
          {
            label: `${this.maintenanceGradeConfigRecord.thirdLevel1}次以上`,
            value: data.carNumberLevel3 || 0,
            unit: '辆',
            tooltip: '按照累计维修次数分级配置规则，分类统计的发生维修车辆数',
          },
        ]

        // 昨日发生维修车辆
        this.maintenanceCarNumberYesterdayData.dataUpdateTime = data.updateTimeOfYesterday || ''
        this.maintenanceCarNumberYesterdayData.primaryDataList = [
          {
            label: '维修车辆数',
            value: data.carNumberOfYesterday || 0,
            unit: '辆',
            tooltip: '昨日发生维修次数大于0的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data.carNumberOfYesterdayDayRadio,
              },
              {
                name: '周同比',
                value: data.carNumberOfYesterdayWeekYoY,
              },
            ],
          },
        ]

        // 本周发生维修车辆
        this.maintenanceCarNumberWeekData.dataUpdateTime = data.updateTimeOfWeek || ''
        this.maintenanceCarNumberWeekData.primaryDataList = [
          {
            label: '维修车辆总数',
            value: data.totalCarNumberOfWeek || 0,
            unit: '辆',
            tooltip: '本周时间段内发生维修次数大于0的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data.totalCarNumberOfWeekRadio,
              },
            ],
          },
        ]
        this.maintenanceCarNumberWeekData.secondaryDataList = [
          {
            label: `${this.maintenanceWeekGradeConfigRecord.firstLevel1}次以下`,
            value: data.carNumberOfWeekLevel1 || 0,
            unit: '辆',
            tooltip: '按照本周维修次数分级配置规则，分类统计的发生维修车辆数',
            ratioList: [
              {
                name: '周环比',
                value: data.carNumberOfWeekLevel1WeekRadio,
              },
            ],
          },
          {
            label: `${this.maintenanceWeekGradeConfigRecord.secondLevel1}~${this.maintenanceWeekGradeConfigRecord.secondLevel2}次`,
            value: data.carNumberOfWeekLevel2 || 0,
            unit: '辆',
            tooltip: '按照本周维修次数分级配置规则，分类统计的发生维修车辆数',
            ratioList: [
              {
                name: '周环比',
                value: data.carNumberOfWeekLevel2WeekRadio,
              },
            ],
          },
          {
            label: `${this.maintenanceWeekGradeConfigRecord.thirdLevel1}次以上`,
            value: data.carNumberOfWeekLevel3 || 0,
            unit: '辆',
            tooltip: '按照本周维修次数分级配置规则，分类统计的发生维修车辆数',
            ratioList: [
              {
                name: '周环比',
                value: data.carNumberOfWeekLevel3WeekRadio,
              },
            ],
          },
        ]

        // 本月发生维修车辆
        this.maintenanceCarNumberMonthData.dataUpdateTime = data.updateTimeOfMonth || ''
        this.maintenanceCarNumberMonthData.primaryDataList = [
          {
            label: '维修车辆总数',
            value: data.totalCarNumberOfMonth || 0,
            unit: '辆',
            tooltip: '本月时间段内发生维修次数大于0的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data.totalCarNumberOfMonthRadio,
              },
            ],
          },
        ]
        this.maintenanceCarNumberMonthData.secondaryDataList = [
          {
            label: `${this.maintenanceMonthGradeConfigRecord.firstLevel1}次以下`,
            value: data.carNumberOfMonthLevel1 || 0,
            unit: '辆',
            tooltip: '按照本月维修次数分级配置规则，分类统计的发生维修车辆数',
            ratioList: [
              {
                name: '月环比',
                value: data.carNumberOfMonthLevel1MonthRadio,
              },
            ],
          },
          {
            label: `${this.maintenanceMonthGradeConfigRecord.secondLevel1}~${this.maintenanceMonthGradeConfigRecord.secondLevel2}次`,
            value: data.carNumberOfMonthLevel2 || 0,
            unit: '辆',
            tooltip: '按照本月维修次数分级配置规则，分类统计的发生维修车辆数',
            ratioList: [
              {
                name: '月环比',
                value: data.carNumberOfMonthLevel2MonthRadio,
              },
            ],
          },
          {
            label: `${this.maintenanceMonthGradeConfigRecord.thirdLevel1}次以上`,
            value: data.carNumberOfMonthLevel3 || 0,
            unit: '辆',
            tooltip: '按照本月维修次数分级配置规则，分类统计的发生维修车辆数',
            ratioList: [
              {
                name: '月环比',
                value: data.carNumberOfMonthLevel3MonthRadio,
              },
            ],
          },
        ]
      }
    },
    // 获取违章情况
    async getVehicleViolationInfo() {
      const res = await getVehicleViolationInfo(this.params)
      const { code, data } = res

      if (code === 1 && data) {
        // 累计违章
        this.violationNumberData.dataUpdateTime = data.updateTimeOfTotal || ''
        this.violationNumberData.primaryDataList = [
          {
            label: '违章车辆数',
            value: data.totalCarNumber || 0,
            unit: '辆',
            tooltip: '截至昨日发生违章次数大于0的车辆累计数量',
          },
          {
            label: '违章次数',
            value: data.totalNumber || 0,
            unit: '次',
            tooltip: '截止昨日累计发生违章次数',
            // 车辆-违章管理-违章记录
            clickCallback: () => this.toViolationRecord({}),
          },
          {
            label: '违章扣分',
            value: data.totalScore || 0,
            unit: '分',
            tooltip: '截止昨日累计产生违章扣分',
            // 车辆-违章管理-违章记录
            clickCallback: () => this.toViolationRecord({}),
          },
          {
            label: '违章罚款',
            value: convertNumber((data.totalFines || 0) / 10000),
            unit: '万元',
            valueTooltip: `${convertNumber(data.totalFines || 0)}元`,
            tooltip: '截止昨日累计产生违章罚款',
            // 车辆-违章管理-违章记录
            clickCallback: () => this.toViolationRecord({}),
          },
        ]

        // 昨日违章
        this.violationNumberYesterdayData.dataUpdateTime = data.updateTimeOfYesterday || ''
        this.violationNumberYesterdayData.primaryDataList = [
          {
            label: '违章车辆数',
            value: data.yesterdayCarNumber || 0,
            unit: '辆',
            tooltip: '昨日发生违章次数大于0的车辆数量',
            ratioList: [
              {
                name: '日环比',
                value: data.yesterdayCarNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.yesterdayCarNumberWeekYoY,
              },
            ],
          },
          {
            label: '违章次数',
            value: data.yesterdayNumber || 0,
            unit: '次',
            tooltip: '昨日累计发生违章次数',
            ratioList: [
              {
                name: '日环比',
                value: data.yesterdayNumberDayRadio,
              },
              {
                name: '周同比',
                value: data.yesterdayNumberWeekYoY,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择昨日进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: yesterday,
            }),
          },
          {
            label: '违章扣分',
            value: data.yesterdayScore || 0,
            unit: '分',
            tooltip: '昨日累计产生违章扣分',
            ratioList: [
              {
                name: '日环比',
                value: data.yesterdayScoreDayRadio,
              },
              {
                name: '周同比',
                value: data.yesterdayScoreWeekYoY,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择昨日进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: yesterday,
            }),
          },
          {
            label: '违章罚款',
            value: convertNumber(data.yesterdayFines || 0),
            unit: '元',
            tooltip: '昨日累计产生违章罚款',
            ratioList: [
              {
                name: '日环比',
                value: data.yesterdayFinesDayRadio,
              },
              {
                name: '周同比',
                value: data.yesterdayFinesWeekYoY,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择昨日进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: yesterday,
            }),
          },
        ]

        // 本周违章
        this.violationNumberWeekData.dataUpdateTime = data.updateTimeOfWeek || ''
        this.violationNumberWeekData.primaryDataList = [
          {
            label: '违章车辆数',
            value: data.weekCarNumber || 0,
            unit: '辆',
            tooltip: '本周时间区间内发生违章次数大于0的车辆数量',
            ratioList: [
              {
                name: '周环比',
                value: data.weekCarNumberRadio,
              },
            ],
          },
          {
            label: '违章次数',
            value: data.weekNumber || 0,
            unit: '次',
            tooltip: '本周时间区间内累计发生违章次数',
            ratioList: [
              {
                name: '周环比',
                value: data.weekNumberRadio,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择本周时间区间进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: thisWeekT_1,
            }),
          },
          {
            label: '违章扣分',
            value: data.weekScore || 0,
            unit: '分',
            tooltip: '本周时间区间内累计产生违章扣分',
            ratioList: [
              {
                name: '周环比',
                value: data.weekScoreRadio,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择本周时间区间进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: thisWeekT_1,
            }),
          },
          {
            label: '违章罚款',
            value: convertNumber(data.weekFines || 0),
            unit: '元',
            tooltip: '本周时间区间内累计产生违章罚款',
            ratioList: [
              {
                name: '周环比',
                value: data.weekFinesRadio,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择本周时间区间进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: thisWeekT_1,
            }),
          },
        ]

        // 本月违章
        this.violationNumberMonthData.dataUpdateTime = data.updateTimeOfMonth || ''
        this.violationNumberMonthData.primaryDataList = [
          {
            label: '违章车辆数',
            value: data.monthCarNumber || 0,
            unit: '辆',
            tooltip: '本月时间区间内发生违章次数大于0的车辆数量',
            ratioList: [
              {
                name: '月环比',
                value: data.monthCarNumberRadio,
              },
            ],
          },
          {
            label: '违章次数',
            value: data.monthNumber || 0,
            unit: '次',
            tooltip: '本月时间区间内累计发生违章次数',
            ratioList: [
              {
                name: '月环比',
                value: data.monthNumberRadio,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择本月时间区间进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: thisMonthT_1,
            }),
          },
          {
            label: '违章扣分',
            value: data.monthScore || 0,
            unit: '分',
            tooltip: '本月时间区间内累计产生违章扣分',
            ratioList: [
              {
                name: '月环比',
                value: data.monthScoreRadio,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择本月时间区间进行检索
            clickCallback: () => this.toViolationRecord({
              violationTime: thisMonthT_1,
            }),
          },
          {
            label: '违章罚款',
            value: convertNumber(data.monthFines || 0),
            unit: '元',
            tooltip: '本月时间区间内累计产生违章罚款',
            ratioList: [
              {
                name: '月环比',
                value: data.monthFinesRadio,
              },
            ],
            // 车辆-违章管理-违章记录，违章时间选择本月时间区间进行检索
            clickCallback: () => this.toViolationRecord({ violationTime: thisMonthT_1 }),
          },
        ]

        // 累计存在待处理违章车辆
        this.violationToDealNumberData.dataUpdateTime = data.updateTime || ''
        this.violationToDealNumberData.primaryDataList = [
          {
            label: '总量',
            value: data.totalCar || 0,
            unit: '辆',
            tooltip: '截止昨日仍存在待处理违章车辆数量',
          },
        ]
        this.violationToDealNumberData.secondaryDataList = [
          {
            label: '风险预警',
            value: data.carLevel1 || 0,
            unit: '辆',
            tooltip: '各公司处于风险预警的车辆数之和',
          },
          {
            label: '高危预警',
            value: data.carLevel2 || 0,
            unit: '辆',
            tooltip: '各公司处于高危预警的车辆数之和',
          },
          {
            label: '风险超时未处理',
            value: data.carLevel3 || 0,
            unit: '辆',
            tooltip: '各公司处于风险超时未处理的车辆数之和',
          },
        ]
      }
    },
    // 获取折旧费分级（最新）
    async getDepreciationGradeConfig() {
      let res

      try {
        res = await getGradeConfig({
          type: 2,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.depreciationGradeConfig = data
      }
    },
    // 获取累计事故次数分级（最新）
    async getAccidentGradeConfig() {
      let res

      try {
        res = await getGradeConfig({
          type: 3,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.accidentGradeConfig = data
      }
    },
    // 获取本周事故次数分级（最新）
    async getAccidentWeekGradeConfig() {
      let res

      try {
        res = await getGradeConfig({
          type: 4,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.accidentWeekGradeConfig = data
      }
    },
    // 获取本月事故次数分级（最新）
    async getAccidentMonthGradeConfig() {
      let res

      try {
        res = await getGradeConfig({
          type: 5,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.accidentMonthGradeConfig = data
      }
    },
    // 获取累计维修次数分级（最新）
    async getMaintenanceGradeConfig() {
      let res

      try {
        res = await getGradeConfig({
          type: 6,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.maintenanceGradeConfig = data
      }
    },
    // 获取本周维修次数分级（最新）
    async getMaintenanceWeekGradeConfig() {
      let res

      try {
        res = await getGradeConfig({
          type: 8,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.maintenanceWeekGradeConfig = data
      }
    },
    // 获取本月维修次数分级（最新）
    async getMaintenanceMonthGradeConfig() {
      let res

      try {
        res = await getGradeConfig({
          type: 7,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.maintenanceMonthGradeConfig = data
      }
    },
    // 获取违章管理分级（最新）
    async getViolationGradeConfig() {
      let res

      try {
        res = await getViolationGradeConfig({
          type: 1,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.violationGradeConfig = data
      }
    },
    // 获取折旧费分级
    async getDepreciationGradeConfigRecord() {
      let res

      try {
        res = await getGradeConfigRecord({
          type: 2,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.depreciationGradeConfigRecord = data
      }
    },
    // 获取累计事故次数分级
    async getAccidentGradeConfigRecord() {
      let res

      try {
        res = await getGradeConfigRecord({
          type: 3,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.accidentGradeConfigRecord = data
      }
    },
    // 获取本周事故次数分级
    async getAccidentWeekGradeConfigRecord() {
      let res

      try {
        res = await getGradeConfigRecord({
          type: 4,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.accidentWeekGradeConfigRecord = data
      }
    },
    // 获取本月事故次数分级
    async getAccidentMonthGradeConfigRecord() {
      let res

      try {
        res = await getGradeConfigRecord({
          type: 5,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.accidentMonthGradeConfigRecord = data
      }
    },
    // 获取累计维修次数分级
    async getMaintenanceGradeConfigRecord() {
      let res

      try {
        res = await getGradeConfigRecord({
          type: 6,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.maintenanceGradeConfigRecord = data
      }
    },
    // 获取本周维修次数分级
    async getMaintenanceWeekGradeConfigRecord() {
      let res

      try {
        res = await getGradeConfigRecord({
          type: 8,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.maintenanceWeekGradeConfigRecord = data
      }
    },
    // 获取本月维修次数分级
    async getMaintenanceMonthGradeConfigRecord() {
      let res

      try {
        res = await getGradeConfigRecord({
          type: 7,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.maintenanceMonthGradeConfigRecord = data
      }
    },
    // 提交折旧费分级
    async submitDepreciationGradeConfig(config) {
      let res

      try {
        res = await saveGradeConfig({
          type: 2,
          content: config,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getDepreciationGradeConfig()
        this.getVehicleDepreciationInfo()
      }
    },
    // 提交累计事故次数分级
    async submitAccidentGradeConfig(config) {
      let res

      try {
        res = await saveGradeConfig({
          type: 3,
          content: config,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getAccidentGradeConfig()
        this.getVehicleAccidentInfo()
      }
    },
    // 提交本周事故次数分级
    async submitAccidentWeekGradeConfig(config) {
      let res

      try {
        res = await saveGradeConfig({
          type: 4,
          content: config,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getAccidentWeekGradeConfig()
        this.getVehicleAccidentInfo()
      }
    },
    // 提交本月事故次数分级
    async submitAccidentMonthGradeConfig(config) {
      let res

      try {
        res = await saveGradeConfig({
          type: 5,
          content: config,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getAccidentMonthGradeConfig()
        this.getVehicleAccidentInfo()
      }
    },
    // 提交累计维修次数分级
    async submitMaintenanceGradeConfig(config) {
      let res

      try {
        res = await saveGradeConfig({
          type: 6,
          content: config,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getMaintenanceGradeConfig()
        this.getVehicleMaintenanceInfo()
      }
    },
    // 提交本周维修次数分级
    async submitMaintenanceWeekGradeConfig(config) {
      let res

      try {
        res = await saveGradeConfig({
          type: 8,
          content: config,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getMaintenanceWeekGradeConfig()
        this.getVehicleMaintenanceInfo()
      }
    },
    // 提交本月维修次数分级
    async submitMaintenanceMonthGradeConfig(config) {
      let res

      try {
        res = await saveGradeConfig({
          type: 7,
          content: config,
        })
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getMaintenanceMonthGradeConfig()
        this.getVehicleMaintenanceInfo()
      }
    },
    // 提交违章管理分级
    async submitViolationGradeConfig(config) {
      let res

      try {
        res = await saveViolationGradeConfig(config)
      } catch (err) {
        console.error(err)
      }

      if (!res) return

      const { code, data } = res

      if (code === 1 && data) {
        this.$message.success('调整配置将于明日生效')
        await this.getViolationGradeConfig()
        this.getVehicleViolationInfo()
      }
    },
    // 维保金额
    async vehicleMaintenancePayInfo() {
      const [err, _data] = await this.$to(vehicleMaintenancePayInfoApi(this.params))
      if (err) return
      const { code, data } = _data
      if (code !== 1) return

      this.maintenanceamount.dataUpdateTime = data.updateTime || ''
      this.maintenanceamount.primaryDataList = [
        {
          label: '近30天累计支付金额',
          value: data.sumPrcPay30d || 0,
          unit: '',
        },
        {
          label: '新增支付金额',
          value: data.sumPrcPay1d || 0,
          unit: '',
          ratioList: [
            {
              name: '日环比',
              value: data.rhbSumPrcPay1d,
            },
            {
              name: '周同比',
              value: data.ztbSumPrcPay1d,
            },
          ],
        },
        {
          label: '新增保养支付金额',
          value: data.sumPrcMaintenanceMainPay1d || 0,
          unit: '',
          ratioList: [
            {
              name: '日环比',
              value: data.rhbSumPrcMaintenanceMainPay1d,
            },
            {
              name: '周同比',
              value: data.ztbSumPrcMaintenanceMainPay1d,
            },
          ],
        },
        {
          label: '新增维修支付金额',
          value: data.sumPrcMaintenanceFixPay1d || 0,
          unit: '',
          ratioList: [
            {
              name: '日环比',
              value: data.rhbSumPrcMaintenanceFixPay1d,
            },
            {
              name: '周同比',
              value: data.ztbSumPrcMaintenanceFixPay1d,
            },
          ],
        },
        {
          label: '历史累计在修车辆',
          value: data.cntCarMaintenanceTd || 0,
          unit: '',
        },
        {
          label: '新增在修车辆',
          value: data.cntCarMaintenance1d || 0,
          unit: '',
          ratioList: [
            {
              name: '日环比',
              value: data.rhbCntCarMaintenance1d,
            },
            {
              name: '周同比',
              value: data.ztbCntCarMaintenance1d,
            },
          ],
        },
        {
          label: '新增维修完成车辆',
          value: data.cntCarMaintenanceComplete1d || 0,
          unit: '',
          ratioList: [
            {
              name: '日环比',
              value: data.rhbCntCarMaintenanceComplete1d,
            },
            {
              name: '周同比',
              value: data.ztbCntCarMaintenanceComplete1d,
            },
          ],
        },
        {
          label: '累计在修超过7天车辆',
          value: data.cntCarMaintenanceOver7dTd || 0,
          unit: '',
          ratioList: [
            {
              name: '日环比',
              value: data.rhbCntCarMaintenanceOver7dTd,
            },
            {
              name: '周同比',
              value: data.ztbCntCarMaintenanceOver7dTd,
            },
          ],
        },
      ]
    },
    // 维修变化趋势
    async vehicleMaintenanceLine() {
      const [err, _data] = await this.$to(vehicleMaintenanceLineApi(this.params))
      if (err) return
      const { code } = _data
      let { data } = _data
      if (code !== 1) return
      if (!data || !data.newMaintenanceLine || !data.allMaintenanceLine) {
        data = { newMaintenanceLine: {}, allMaintenanceLine: {} }
      }
      this.newAddMaintenanceData.dataUpdateTime = data.updateTime || ''

      const dataList = data.newMaintenanceLine.dataList || []
      // 图例（公司名称 或 车型名称）
      this.newAddMaintenanceData.legendData = data.newMaintenanceLine.nameList || []
      this.newAddMaintenanceData.xAxis.data = dataList.map((item) => item.ds) || []
      this.newAddMaintenanceData.seriesData = this.newAddMaintenanceData.legendData.map((item) => {
        return {
          // 系列名称
          name: item,
          data: dataList.map((itm) => {
            const deptInfo = itm.deptList.find((dept) => dept.deptName === item)
            // X轴数据
            const date = itm.ds
            // Y轴数据
            const value = deptInfo?.value || 0
            return [
              date,
              value,
            ]
          }),
        }
      })


      this.totalMaintenanceData.dataUpdateTime = data.updateTime || ''
      const allDataList = data.allMaintenanceLine.dataList || []
      // 图例（公司名称 或 车型名称）
      this.totalMaintenanceData.legendData = data.allMaintenanceLine.nameList || []
      this.totalMaintenanceData.xAxis.data = allDataList.map((item) => item.ds) || []
      this.totalMaintenanceData.seriesData = this.totalMaintenanceData.legendData.map((item) => {
        return {
          // 系列名称
          name: item,
          data: allDataList.map((itm) => {
            const deptInfo = itm.deptList.find((dept) => dept.deptName === item)
            // X轴数据
            const date = itm.ds
            // Y轴数据
            const value = deptInfo?.value || 0
            return [
              date,
              value,
            ]
          }),
        }
      })
    },
    async vehicleMaintenanceDistribution() {
      const [err, _data] = await this.$to(vehicleMaintenanceDistributionApi(this.params))
      if (err) return
      const { code } = _data
      let { data } = _data
      if (code !== 1) return
      if (!data) {
        data = {
          // 新增新增在修车辆城市分布
          newMaintenanceCityDistributionList: [],
          // 新增在修车辆门店分布
          newMaintenanceStoreDistributionList: [],
          // 存量在修车辆城市分布
          allMaintenanceCityDistributionList: [],
          // 存量在修车辆门店分布
          allMaintenanceStoreDistributionList: [],
        }
      }

      if (!Array.isArray(data.newMaintenanceCityDistributionList)) {
        data.newMaintenanceCityDistributionList = []
      }

      if (!Array.isArray(data.newMaintenanceStoreDistributionList)) {
        data.newMaintenanceStoreDistributionList = []
      }

      if (!Array.isArray(data.allMaintenanceCityDistributionList)) {
        data.allMaintenanceCityDistributionList = []
      }

      if (!Array.isArray(data.allMaintenanceStoreDistributionList)) {
        data.allMaintenanceStoreDistributionList = []
      }

      this.newAddCitySpread.dataUpdateTime = data.updateTime || ''
      // 图例（公司名称 或 车型名称）
      this.newAddCitySpread.seriesData = [{
        data: data.newMaintenanceCityDistributionList.map((item) => item.value),
        type: 'bar',
        label: {
          show: true,
          position: 'right',
        },
      }]
      this.newAddCitySpread.yAxis.data =
      data.newMaintenanceCityDistributionList.map((item) => item.name)
      this.newAddCitySpread.legendData =
      data.newMaintenanceCityDistributionList.map((item) => item.name)
      this.newAddCitySpread.height = this.newAddCitySpread.yAxis.data.length * 28


      this.newAddStoreSpread.dataUpdateTime = data.updateTime || ''
      this.newAddStoreSpread.seriesData = [{
        data: data.newMaintenanceStoreDistributionList.map((item) => item.value),
        type: 'bar',
        label: {
          show: true,
          position: 'right',
        },
      }]
      this.newAddStoreSpread.yAxis.data =
      data.newMaintenanceStoreDistributionList.map((item) => item.name)
      this.newAddStoreSpread.height = this.newAddStoreSpread.yAxis.data.length * 28


      this.curCitySpread.dataUpdateTime = data.updateTime || ''
      this.curCitySpread.seriesData = [{
        data: data.allMaintenanceCityDistributionList.map((item) => item.value),
        type: 'bar',
        barGap: '10%',
        label: {
          show: true,
          position: 'right',
        },
      }]
      this.curCitySpread.yAxis.data =
      data.allMaintenanceCityDistributionList.map((item) => item.name)
      this.curCitySpread.height = this.curCitySpread.yAxis.data.length * 28


      this.curStoreSpread.dataUpdateTime = data.updateTime || ''
      this.curStoreSpread.seriesData = [{
        data: data.allMaintenanceStoreDistributionList.map((item) => item.value),
        type: 'bar',
        barGap: '10%',
        label: {
          show: true,
          position: 'right',
        },
      }]
      this.curStoreSpread.yAxis.data =
      data.allMaintenanceStoreDistributionList.map((item) => item.name)
      this.curStoreSpread.height = this.curStoreSpread.yAxis.data.length * 28
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
.module-title {
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: 600;
  line-height: 22px;
  color: #3D3D3D;
}
</style>
